import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getAgreementValidations: ['codigoTramite', 'dni'],
  getAgreementValidationsRequest: null,
  getAgreementValidationsSuccess: null,
  getAgreementValidationsFailure: ['error']
});

export { Creators, Types };
